export default "__VITE_ASSET__DABKcAmK__"